
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/errors",
      function () {
        return require("private-next-pages/examples/errors.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/errors"])
      });
    }
  